import PortalVue from 'portal-vue';

export default defineNuxtPlugin({
    name: 'portal',
    dependsOn: [],
    async setup(nuxtApp)
    {
        nuxtApp.vueApp.use(PortalVue);
    }
});
